module.exports = __webpack_public_path__ + "static/media/lexicos.1dbeffa6.md";